import quickFetch from 'quick-fetch';
const AUTH_TIMEOUT_MS = 3000;
export const extractUserId = info => info.user.user_id;

// Default provider: the login-verify request is already in flight during
// quickFetch bootstrap, so read the user id off afterAuth. Reject if auth never
// resolves within the timeout — callers skip the request rather than fetch
// unscoped (potentially wrong) data.
export const readUserIdFromAuth = () => new Promise((resolve, reject) => {
  const timeout = setTimeout(() => reject(new Error('Timed out reading userId from auth')), AUTH_TIMEOUT_MS);
  quickFetch.afterAuth(auth => {
    var _auth$user;
    clearTimeout(timeout);
    resolve(auth === null || auth === void 0 || (_auth$user = auth.user) === null || _auth$user === void 0 ? void 0 : _auth$user.user_id);
  });
});